var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04688 12.875V9.125",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 11H7.125",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.75V13.25C16.5 16.25 15.75 17 12.75 17H5.25C2.25 17 1.5 16.25 1.5 13.25V5.75C1.5 2.75 2.25 2 5.25 2H6.375C7.5 2 7.7475 2.33 8.175 2.9L9.3 4.4C9.585 4.775 9.75 5 10.5 5H12.75C15.75 5 16.5 5.75 16.5 8.75Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderAddIcon);
export default __webpack_public_path__ + "static/media/folder-addIcon.ccd5ac4d7dfd29da5cce7b71e3f7a9fa.svg";
export { ForwardRef as ReactComponent };